import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyCallGroups = lazy(() => import('./svg-components/call-groups'));

const CallGroups = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyCallGroups {...rest} />
  </Suspense>
);

export default CallGroups;
